import { render, staticRenderFns } from "./MortgageReviewCard.vue?vue&type=template&id=43d78140"
import script from "./MortgageReviewCard.vue?vue&type=script&lang=js"
export * from "./MortgageReviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports